import Head from 'next/head';
import App from 'next/app';
import React from 'react';
import { MyAppPropsTypes, MyAppTypes } from '../types/MyAppTypes';
import { wrapper as storeWrapper, store } from '../store';

class MyApp extends App {
  static async getInitialProps({ Component, ctx }: MyAppTypes) {
    return {
      pageProps: Component.getInitialProps
        ? await Component.getInitialProps(ctx)
        : {},
    };
  }

  render() {
    const { Component, pageProps }: MyAppPropsTypes = this.props;
    const ComponentElement: any = Component;

    if (typeof window !== 'undefined' && store && store.getState().server.environment !== 'production') {
      window.store = store;
    }

    return (
      <>
        <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale = 1.0"
          />
        </Head>
        <ComponentElement {...pageProps} />
      </>
    );
  }
}

export default storeWrapper.withRedux(MyApp);
